// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ReactResponsive from "react-responsive";

function useMediaQuery(s) {
  return ReactResponsive.useMediaQuery({
              query: s
            });
}

export {
  useMediaQuery ,
}
/* react-responsive Not a pure module */
